module.exports = "../images/icons/mail.svg";